import { render, staticRenderFns } from "./DailyTestdetails.vue?vue&type=template&id=1e8eb746"
import script from "./DailyTestdetails.vue?vue&type=script&lang=js"
export * from "./DailyTestdetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports